import { TicketIcon, GradientTicketIcon } from 'root/src/client/public/icons/TicketIcon';
import { twMerge } from 'tailwind-merge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/pro-regular-svg-icons/faLock';
import { BaseTooltip, BaseTooltipContent } from 'root/src/client/v2/common/components/BaseTooltip/BaseTooltip';
import { getMessageLockedByTier } from 'root/src/client/v2/battlePass/helpers/battlePassMessage.helpers';
export const TierBadge = ({ label, isActive = false, className, onClick, isLocked = false, tier }) => {
    const onBadge = () => {
        if (onClick) {
            onClick();
        }
    };
    return (<div className={twMerge('flex relative items-center w-44 justify-center cursor-pointer', className)} onClick={onBadge}>
			{isLocked && (<div className="absolute top-[43px] right-3">
					<TierBadgeLock isActive={isActive} description={getMessageLockedByTier(tier)}/>
				</div>)}
			<TicketIcon gradient={isActive ? GradientTicketIcon.Purple : GradientTicketIcon.Grey}/>
			<p className="absolute mr-4 uppercase font-medium select-none">{label}</p>
		</div>);
};
const TierBadgeLock = ({ description, isActive }) => {
    return (<BaseTooltip tooltip={description && (<BaseTooltipContent className="flex flex-col justify-center items-center">
					{description}
				</BaseTooltipContent>)}>
			<div data-active={isActive} className="flex items-center bg-black rounded-full p-[7px] data-[active=true]:border-primary border-2 border-dark-3">
				<FontAwesomeIcon size="sm" icon={faLock}/>
			</div>
		</BaseTooltip>);
};
